import { MOKA_INVENTORY_API } from '../constants';

export const GRATUITIES = `${MOKA_INVENTORY_API}/v2/gratuities`;

export const V1_GRATUITIES = `${MOKA_INVENTORY_API}/v1/gratuities`;
export const GRATUITY_BY_ID = (id) =>
  `${MOKA_INVENTORY_API}/v1/gratuities/${id}`;
export const CREATE_ALL_OUTLET = `${MOKA_INVENTORY_API}/v1/gratuities/create_all_outlet`;
